import { Input } from 'antd'
import { NodePicker } from 'Components'

export fieldData = [{
  fieldName: 'sourceType',
  Component: NodePicker,
  editable: true
  helpText: "The type node for which all members act as source nodes."
  required: true
}
{
  fieldName: 'sourceAttrKey',
  Component: Input,
  editable: false,
  helpText: "The attribute of the source node to be transformed."
}
{
  fieldName: 'targetType',
  Component: Input,
  editable: true,
  required: true
  helpText: "Attribute key of all target nodes for which the value matches the value in the attribute key of source node(s)."
}
{
  fieldName: 'targetAttrKey',
  Component: Input,
  editable: true,
  required: true
  helpText: "Newly created relation key to use."
}
{
  fieldName: 'nameKey',
  Component: Input,
  editable: true,
  required: false
  helpText: "Newly created relation key to use."
}
{
  fieldName: 'memberKey',
  Component: Input,
  editable: true,
  required: true
  helpText: "Member key"
}]
